import { render, staticRenderFns } from "./CatalogSlider.vue?vue&type=template&id=6576997d"
import script from "./CatalogSlider.vue?vue&type=script&lang=ts"
export * from "./CatalogSlider.vue?vue&type=script&lang=ts"
import style0 from "./CatalogSlider.vue?vue&type=style&index=0&id=6576997d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports